import React, { useState, useEffect } from 'react';
import { Modal, Button, Row, Col, Alert } from 'react-bootstrap'; // 保持原有的组件
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';
import { FaExclamationCircle } from 'react-icons/fa'; // 保留引入感叹号图标
import { useTranslation } from 'react-i18next'; // 引入 useTranslation


const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

const PaymentModal = ({ show, handleClose, selectedPackage, currency}) => {
  const [step, setStep] = useState(1);
  const [clientSecret, setClientSecret] = useState('');
  const { t } = useTranslation(); // 初始化 t 函数
  const userId = sessionStorage.getItem('userId');

  const currencySymbols = {
    USD: '$',    // 美元
    CNY: '¥',    // 人民币
    CAD: 'C$',   // 加元
  }

  useEffect(() => {
    const createPaymentIntent = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/create_payment`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            user_id: userId,
            amount: selectedPackage.price,
            currency: currency
          })
        });
        const data = await response.json();
        setClientSecret(data.clientSecret);
      } catch (error) {
        console.error('Error creating payment intent:', error);
      }
    };

    if (step === 2) {
      createPaymentIntent();
    }
  }, [step, selectedPackage, userId]);

  return (
    <Modal show={show} onHide={handleClose} centered>
      {step === 1 ? (
        <>
          <Modal.Header closeButton>
            <Modal.Title>{t('order_summary')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="mb-3">
              <Col xs={6}><strong>{selectedPackage.credits} {t('credits')}</strong></Col>
              <Col xs={6} className="text-end"><strong>{currencySymbols[currency]}{selectedPackage.price / 100}</strong></Col>
            </Row>
            <hr />
            <Row className="mb-3">
              <Col xs={6}>{t('subtotal')}</Col>
              <Col xs={6} className="text-end">{currencySymbols[currency]}{selectedPackage.price / 100}</Col>
            </Row>
            <hr />
            <Row className="mb-3">
              <Col xs={6}><strong>{t('total')}</strong></Col>
              <Col xs={6} className="text-end"><strong>{currencySymbols[currency]}{selectedPackage.price / 100}</strong></Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button 
              variant="success" 
              className="w-100" 
              onClick={() => setStep(2)}
            >
              {t('proceed_to_payment')}
            </Button>
          </Modal.Footer>
        </>
      ) : (
        <>
          <Modal.Header closeButton>
            <Modal.Title>{t('payment')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {clientSecret && (
              <Elements stripe={stripePromise} options={{ clientSecret }}>
                <CheckoutForm clientSecret={clientSecret} />
              </Elements>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              {t('cancel')}
            </Button>
          </Modal.Footer>
        </>
      )}
    </Modal>
  );
};

export default PaymentModal;
